"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * ECR Public gallery
 * This is an API used in Spencer gallery API Gateway to proxy request to ECR Public.
 *
 * The version of the OpenAPI document: 1.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class DefaultApi extends runtime.BaseAPI {
    /**
     * Find image tag information in the system for an image
     * get details of an imageTag item
     */
    async describeImageTagsRaw(requestParameters, initOverrides) {
        if (requestParameters.describeImageTagsRequest === null || requestParameters.describeImageTagsRequest === undefined) {
            throw new runtime.RequiredError('describeImageTagsRequest', 'Required parameter requestParameters.describeImageTagsRequest was null or undefined when calling describeImageTags.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/describeImageTags`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.DescribeImageTagsRequestToJSON)(requestParameters.describeImageTagsRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.DescribeImageTagsResponseFromJSON)(jsonValue));
    }
    /**
     * Find image tag information in the system for an image
     * get details of an imageTag item
     */
    async describeImageTags(requestParameters, initOverrides) {
        const response = await this.describeImageTagsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Find a repository matching the input parameters in the system
     * get details of an repository item
     */
    async describeRepositoryCatalogDataRaw(requestParameters, initOverrides) {
        if (requestParameters.describeRepositoryCatalogDataRequest === null || requestParameters.describeRepositoryCatalogDataRequest === undefined) {
            throw new runtime.RequiredError('describeRepositoryCatalogDataRequest', 'Required parameter requestParameters.describeRepositoryCatalogDataRequest was null or undefined when calling describeRepositoryCatalogData.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/describeRepositoryCatalogData`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.DescribeRepositoryCatalogDataRequestToJSON)(requestParameters.describeRepositoryCatalogDataRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.DescribeRepositoryCatalogDataResponseFromJSON)(jsonValue));
    }
    /**
     * Find a repository matching the input parameters in the system
     * get details of an repository item
     */
    async describeRepositoryCatalogData(requestParameters, initOverrides) {
        const response = await this.describeRepositoryCatalogDataRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Adds an item to the system
     * get details of an registry item
     */
    async getRegistryCatalogDataRaw(requestParameters, initOverrides) {
        if (requestParameters.getRegistryCatalogDataRequest === null || requestParameters.getRegistryCatalogDataRequest === undefined) {
            throw new runtime.RequiredError('getRegistryCatalogDataRequest', 'Required parameter requestParameters.getRegistryCatalogDataRequest was null or undefined when calling getRegistryCatalogData.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/getRegistryCatalogData`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.GetRegistryCatalogDataRequestToJSON)(requestParameters.getRegistryCatalogDataRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GetRegistryCatalogDataResponseFromJSON)(jsonValue));
    }
    /**
     * Adds an item to the system
     * get details of an registry item
     */
    async getRegistryCatalogData(requestParameters, initOverrides) {
        const response = await this.getRegistryCatalogDataRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Find a repository in the system matching the input values
     * get details of an repository item
     */
    async getRepositoryCatalogDataRaw(requestParameters, initOverrides) {
        if (requestParameters.getRepositoryCatalogDataRequest === null || requestParameters.getRepositoryCatalogDataRequest === undefined) {
            throw new runtime.RequiredError('getRepositoryCatalogDataRequest', 'Required parameter requestParameters.getRepositoryCatalogDataRequest was null or undefined when calling getRepositoryCatalogData.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/getRepositoryCatalogData`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.GetRepositoryCatalogDataRequestToJSON)(requestParameters.getRepositoryCatalogDataRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GetRepositoryCatalogDataResponseFromJSON)(jsonValue));
    }
    /**
     * Find a repository in the system matching the input values
     * get details of an repository item
     */
    async getRepositoryCatalogData(requestParameters, initOverrides) {
        const response = await this.getRepositoryCatalogDataRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Send telemetry events regarding ECR Public Gallery performance and user behavior.
     * send telemetry events about user behavior and performance.
     */
    async putCustomerMonitoringEventsAppmonitors26f72e74586543fd9c27Cc5ff272773aRaw(requestParameters, initOverrides) {
        if (requestParameters.putCustomerMonitoringEventsRequest === null || requestParameters.putCustomerMonitoringEventsRequest === undefined) {
            throw new runtime.RequiredError('putCustomerMonitoringEventsRequest', 'Required parameter requestParameters.putCustomerMonitoringEventsRequest was null or undefined when calling putCustomerMonitoringEventsAppmonitors26f72e74586543fd9c27Cc5ff272773a.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/putCustomerMonitoringEvents/appmonitors/26f72e74-5865-43fd-9c27-cc5ff272773a`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.PutCustomerMonitoringEventsRequestToJSON)(requestParameters.putCustomerMonitoringEventsRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Send telemetry events regarding ECR Public Gallery performance and user behavior.
     * send telemetry events about user behavior and performance.
     */
    async putCustomerMonitoringEventsAppmonitors26f72e74586543fd9c27Cc5ff272773a(requestParameters, initOverrides) {
        const response = await this.putCustomerMonitoringEventsAppmonitors26f72e74586543fd9c27Cc5ff272773aRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Send telemetry events regarding ECR Public Gallery performance and user behavior.
     * send telemetry events about user behavior and performance.
     */
    async putCustomerMonitoringEventsAppmonitors8449e561223949359c7cF5a6e0f308d6Raw(requestParameters, initOverrides) {
        if (requestParameters.putCustomerMonitoringEventsRequest === null || requestParameters.putCustomerMonitoringEventsRequest === undefined) {
            throw new runtime.RequiredError('putCustomerMonitoringEventsRequest', 'Required parameter requestParameters.putCustomerMonitoringEventsRequest was null or undefined when calling putCustomerMonitoringEventsAppmonitors8449e561223949359c7cF5a6e0f308d6.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/putCustomerMonitoringEvents/appmonitors/8449e561-2239-4935-9c7c-f5a6e0f308d6`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.PutCustomerMonitoringEventsRequestToJSON)(requestParameters.putCustomerMonitoringEventsRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Send telemetry events regarding ECR Public Gallery performance and user behavior.
     * send telemetry events about user behavior and performance.
     */
    async putCustomerMonitoringEventsAppmonitors8449e561223949359c7cF5a6e0f308d6(requestParameters, initOverrides) {
        const response = await this.putCustomerMonitoringEventsAppmonitors8449e561223949359c7cF5a6e0f308d6Raw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Send telemetry events regarding ECR Public Gallery performance and user behavior.
     * send telemetry events about user behavior and performance.
     */
    async putCustomerMonitoringEventsAppmonitorsB90aab51E321432a8edeE70aa8a3fcb3Raw(requestParameters, initOverrides) {
        if (requestParameters.putCustomerMonitoringEventsRequest === null || requestParameters.putCustomerMonitoringEventsRequest === undefined) {
            throw new runtime.RequiredError('putCustomerMonitoringEventsRequest', 'Required parameter requestParameters.putCustomerMonitoringEventsRequest was null or undefined when calling putCustomerMonitoringEventsAppmonitorsB90aab51E321432a8edeE70aa8a3fcb3.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/putCustomerMonitoringEvents/appmonitors/b90aab51-e321-432a-8ede-e70aa8a3fcb3`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.PutCustomerMonitoringEventsRequestToJSON)(requestParameters.putCustomerMonitoringEventsRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Send telemetry events regarding ECR Public Gallery performance and user behavior.
     * send telemetry events about user behavior and performance.
     */
    async putCustomerMonitoringEventsAppmonitorsB90aab51E321432a8edeE70aa8a3fcb3(requestParameters, initOverrides) {
        const response = await this.putCustomerMonitoringEventsAppmonitorsB90aab51E321432a8edeE70aa8a3fcb3Raw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Find a repository matching the input parameters in the system
     * search repositories that matches search critria
     */
    async searchRepositoryCatalogDataRaw(requestParameters, initOverrides) {
        if (requestParameters.searchRepositoryCatalogDataRequest === null || requestParameters.searchRepositoryCatalogDataRequest === undefined) {
            throw new runtime.RequiredError('searchRepositoryCatalogDataRequest', 'Required parameter requestParameters.searchRepositoryCatalogDataRequest was null or undefined when calling searchRepositoryCatalogData.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/searchRepositoryCatalogData`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.SearchRepositoryCatalogDataRequestToJSON)(requestParameters.searchRepositoryCatalogDataRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.SearchRepositoryCatalogDataResponseFromJSON)(jsonValue));
    }
    /**
     * Find a repository matching the input parameters in the system
     * search repositories that matches search critria
     */
    async searchRepositoryCatalogData(requestParameters, initOverrides) {
        const response = await this.searchRepositoryCatalogDataRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
exports.DefaultApi = DefaultApi;
